export const bookingsFilter = {
  name: "bookingFilter",
  criterions: [
    {
      monthToBack: 1,
      fromDataType: 4,
      toDataType: 0,
      value: {
        fromIsSelected: true,
        fromValue: "2021-01-01T00:00:00",
        toIsSelected: false,
        toValue: "2021-02-15T23:59:59.999",
      },
      type: "DateFromToCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Okres",
      propertyName: "Period",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 1,
          stringKey: null,
          stringValue: "Ostatnia modyfikacja",
          tooltipValue: "",
        },
        {
          intKey: 2,
          stringKey: null,
          stringValue: "Utworzone w systemie",
          tooltipValue: "",
        },
        {
          intKey: 3,
          stringKey: null,
          stringValue: "Utworzone u operatora",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: null,
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Okres po",
      propertyName: "DatePeriodFilter",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 2,
      label: "Nr biletu/rez.",
      propertyName: "TicketNumber",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 3,
      label: "Nazwisko pasażera",
      propertyName: "PassengerName",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 200,
      value: null,
      UniqueId: null,
      type: "AutocompleteTextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 4,
      label: "Kontrahent",
      propertyName: "PropertyName_ContractorsAutocompleteOnlyBuyers",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 200,
      enumCriterionType: 0,
      enumCriterionOwnerItems: [
        {
          ownerId: 0,
          intKey: 0,
          stringKey: "00000000-0000-0000-0000-000000000000",
          stringValue: "Wszyscy",
          tooltipValue: "",
        },
        {
          ownerId: 118,
          intKey: 0,
          stringKey: "6f9f3d55-525c-4848-9877-fc89fb411596",
          stringValue: "",
          tooltipValue: "",
        },
        {
          ownerId: 132,
          intKey: 0,
          stringKey: "79a5539a-8959-4d04-96c8-1601a1f016e1",
          stringValue: "",
          tooltipValue: "",
        },
        {
          ownerId: 94,
          intKey: 0,
          stringKey: "7c3aab47-e78a-47ad-9d13-5f661c21e1bb",
          stringValue: "Agnieszka Jaworska",
          tooltipValue: "",
        },
        {
          ownerId: 114,
          intKey: 0,
          stringKey: "50c3ba3e-9bfd-40f6-a0cd-3f37f19130da",
          stringValue: "Agnieszka Tybuszewska",
          tooltipValue: "",
        },
        {
          ownerId: 83,
          intKey: 0,
          stringKey: "91de27dd-95ef-474a-bd6f-62f8d63f64c0",
          stringValue: "Alicja Ślemp",
          tooltipValue: "",
        },
        {
          ownerId: 100,
          intKey: 0,
          stringKey: "b71120a5-acf8-41c0-90f6-9937d6e81c01",
          stringValue: "Alicja Tutak",
          tooltipValue: "",
        },
        {
          ownerId: 270,
          intKey: 0,
          stringKey: "a81cfcd7-1fae-4f95-a066-f06a8d363a0d",
          stringValue: "Andżelika Kulik",
          tooltipValue: "",
        },
        {
          ownerId: 161,
          intKey: 0,
          stringKey: "5975362e-a176-42b0-95e7-64a2a1786a6d",
          stringValue: "Aneta Nowak",
          tooltipValue: "",
        },
        {
          ownerId: 232,
          intKey: 0,
          stringKey: "0751a92c-dadd-4e83-87c4-3b9a53e3a9a3",
          stringValue: "Angela Virstyuk",
          tooltipValue: "",
        },
        {
          ownerId: 189,
          intKey: 0,
          stringKey: "335c8f3f-4ef4-410c-94a4-9936626b3d9a",
          stringValue: "Angelika Giżka",
          tooltipValue: "",
        },
        {
          ownerId: 262,
          intKey: 0,
          stringKey: "2a3db0b5-8849-4daf-9eef-d7f4cb35c9e2",
          stringValue: "Anna Augustyn-Wacha",
          tooltipValue: "",
        },
        {
          ownerId: 134,
          intKey: 0,
          stringKey: "b76a4133-0912-46cc-9d0c-5833a9e0dd1e",
          stringValue: "Anna Paradowska",
          tooltipValue: "",
        },
        {
          ownerId: 127,
          intKey: 0,
          stringKey: "1c0069cb-1ffd-416e-aee0-29bc6e23c290",
          stringValue: "Anna Pawlik-Kuś",
          tooltipValue: "",
        },
        {
          ownerId: 88,
          intKey: 0,
          stringKey: "af82b39d-9374-4c7a-9a17-f1f7303cd3cf",
          stringValue: "Anna Szczudlik",
          tooltipValue: "",
        },
        {
          ownerId: 135,
          intKey: 0,
          stringKey: "a02bfefe-d7dd-483b-b62e-d01db8a39c60",
          stringValue: "Anna Wójcik",
          tooltipValue: "",
        },
        {
          ownerId: 209,
          intKey: 0,
          stringKey: "ea97f9a1-7a1a-4520-8ca6-8b096160fc33",
          stringValue: "Barbara Bąk",
          tooltipValue: "",
        },
        {
          ownerId: 85,
          intKey: 0,
          stringKey: "900dcaa2-355e-4543-9b41-512915be2d69",
          stringValue: "Barbara Micał",
          tooltipValue: "",
        },
        {
          ownerId: 5,
          intKey: 0,
          stringKey: "375e763d-3d2c-4517-b487-8d7997da12d1",
          stringValue: "Beata Malec",
          tooltipValue: "",
        },
        {
          ownerId: 239,
          intKey: 0,
          stringKey: "f5100167-66cb-4ae8-a7bf-607bf7f5df35",
          stringValue: "Beata Sienko",
          tooltipValue: "",
        },
        {
          ownerId: 218,
          intKey: 0,
          stringKey: "8f06dbe9-0cfc-4cce-9113-b11422b3d3b6",
          stringValue: "Dagny Chrenkoff-Bączyńska",
          tooltipValue: "",
        },
        {
          ownerId: 205,
          intKey: 0,
          stringKey: "8dfadc19-a395-4951-8259-1263e0434f80",
          stringValue: "Elżbieta Chrzan",
          tooltipValue: "",
        },
        {
          ownerId: 177,
          intKey: 0,
          stringKey: "0c56942c-70b6-40cc-bf59-aceb55285a5c",
          stringValue: "Emergency",
          tooltipValue: "",
        },
        {
          ownerId: 6,
          intKey: 0,
          stringKey: "6201679d-23f2-4115-959f-18e3ccfc4bde",
          stringValue: "Ewa Bednarek",
          tooltipValue: "",
        },
        {
          ownerId: 120,
          intKey: 0,
          stringKey: "3b5ee31f-e485-4ceb-a979-2325c8c11186",
          stringValue: "Ewelina Madejczyk",
          tooltipValue: "",
        },
        {
          ownerId: 263,
          intKey: 0,
          stringKey: "eb16cc45-187a-44a9-9fca-62805c5b5be2",
          stringValue: "Grupa Hotele",
          tooltipValue: "",
        },
        {
          ownerId: 264,
          intKey: 0,
          stringKey: "035becac-e1dd-4d0e-a016-32d6ebab5291",
          stringValue: "Grupa Logistyka",
          tooltipValue: "",
        },
        {
          ownerId: 253,
          intKey: 0,
          stringKey: "39e9aa8c-ecd4-4881-90e6-efeee4b86a9d",
          stringValue: "Izabela Maleszka",
          tooltipValue: "",
        },
        {
          ownerId: 213,
          intKey: 0,
          stringKey: "03de0032-f1ca-4348-96c2-9eebdf8ee264",
          stringValue: "Izabela Matuszczak",
          tooltipValue: "",
        },
        {
          ownerId: 179,
          intKey: 0,
          stringKey: "6a8cb67a-479e-4a06-af04-dcd013830863",
          stringValue: "Jakub Nestorowicz",
          tooltipValue: "",
        },
        {
          ownerId: 4,
          intKey: 0,
          stringKey: "91b5393e-ae1c-40ba-abcc-9927b672d85a",
          stringValue: "Joanna Smalec",
          tooltipValue: "",
        },
        {
          ownerId: 10,
          intKey: 0,
          stringKey: "075063e2-bb69-4ae7-9cf1-c76260451934",
          stringValue: "Kamil Stec",
          tooltipValue: "",
        },
        {
          ownerId: 219,
          intKey: 0,
          stringKey: "74bc92b7-528e-45b6-b172-e1b1daaeb6c8",
          stringValue: "Kasjer hotelowy",
          tooltipValue: "",
        },
        {
          ownerId: 265,
          intKey: 0,
          stringKey: "c6d34963-a71f-4d32-94ab-19134e60777f",
          stringValue: "Kasjerzy Kielnarowa",
          tooltipValue: "",
        },
        {
          ownerId: 266,
          intKey: 0,
          stringKey: "bda102d6-b440-4925-91ef-87f7e5507b7e",
          stringValue: "Kasjerzy Rzeszów",
          tooltipValue: "",
        },
        {
          ownerId: 9,
          intKey: 0,
          stringKey: "b5d967c9-2bf5-402a-b64b-c14400efaf68",
          stringValue: "Katarzyna Lutomska",
          tooltipValue: "",
        },
        {
          ownerId: 241,
          intKey: 0,
          stringKey: "4871afe7-30f1-4736-8ca5-78198c9d5e63",
          stringValue: "Katrzyna Żuryło",
          tooltipValue: "",
        },
        {
          ownerId: 82,
          intKey: 0,
          stringKey: "5ffb3eeb-7b23-4231-8caf-43476320efc9",
          stringValue: "Kinga Guz",
          tooltipValue: "",
        },
        {
          ownerId: 78,
          intKey: 0,
          stringKey: "b85900aa-a514-4d0e-8e02-e8caa959c1e5",
          stringValue: "Klaudia Padwińska",
          tooltipValue: "",
        },
        {
          ownerId: 244,
          intKey: 0,
          stringKey: "a9f5a617-da2d-40df-9d16-598edb12d78b",
          stringValue: "Konrad Tarczyński",
          tooltipValue: "",
        },
        {
          ownerId: 11,
          intKey: 0,
          stringKey: "2308ae86-5112-40e2-b4bc-581b8ba91add",
          stringValue: "Krystyna Szela",
          tooltipValue: "",
        },
        {
          ownerId: 98,
          intKey: 0,
          stringKey: "687d7163-85a9-40a7-85a4-86175bd4b5d0",
          stringValue: "Krzysztof Murias",
          tooltipValue: "",
        },
        {
          ownerId: 12,
          intKey: 0,
          stringKey: "6072d51d-02b4-4940-933f-01f6955dcd2b",
          stringValue: "Lidia Socha",
          tooltipValue: "",
        },
        {
          ownerId: 101,
          intKey: 0,
          stringKey: "274dd604-f736-483b-bf5b-9a9fcb8534ed",
          stringValue: "Łukasz Reizer",
          tooltipValue: "",
        },
        {
          ownerId: 16,
          intKey: 0,
          stringKey: "0f290f2a-daab-4178-9819-095e17588fbb",
          stringValue: "Maciej Szczudlik",
          tooltipValue: "",
        },
        {
          ownerId: 199,
          intKey: 0,
          stringKey: "9db33240-108d-44de-aaf7-cde87d6736a9",
          stringValue: "Magdalena Ziomek",
          tooltipValue: "",
        },
        {
          ownerId: 204,
          intKey: 0,
          stringKey: "df3ee048-1ccd-46cb-9726-f21cae402395",
          stringValue: "Małgorzata Lew",
          tooltipValue: "",
        },
        {
          ownerId: 13,
          intKey: 0,
          stringKey: "dd17a258-931c-4985-9189-3ecf7dec5d46",
          stringValue: "Małgorzata Lorenc",
          tooltipValue: "",
        },
        {
          ownerId: 166,
          intKey: 0,
          stringKey: "2f8c89d7-fc0d-491e-a0cb-a90bec6787c4",
          stringValue: "Małgorzata Winiecka",
          tooltipValue: "",
        },
        {
          ownerId: 107,
          intKey: 0,
          stringKey: "42351e85-601e-4ac0-8e6f-02eece3178c5",
          stringValue: "Marianna Giefert",
          tooltipValue: "",
        },
        {
          $id: "67",
          ownerId: 87,
          intKey: 0,
          stringKey: "23ebf09c-f895-4908-a623-8755a9903c2d",
          stringValue: "Marta Trojanowska",
          tooltipValue: "",
        },
        {
          ownerId: 141,
          intKey: 0,
          stringKey: "240accc4-a8a0-41f2-b35f-0178217aee5f",
          stringValue: "Marzena Machnicka",
          tooltipValue: "",
        },
        {
          ownerId: 210,
          intKey: 0,
          stringKey: "84443f59-b20a-4d93-bbd8-ede20fd03dba",
          stringValue: "Monika Kuźniar",
          tooltipValue: "",
        },
        {
          ownerId: 128,
          intKey: 0,
          stringKey: "a2a4df2d-291a-4cfc-8b98-e3f85d5719ce",
          stringValue: "Monika Lachtara",
          tooltipValue: "",
        },
        {
          ownerId: 86,
          intKey: 0,
          stringKey: "6656a3c7-2ac0-4408-b505-c232c8cbd912",
          stringValue: "Monika Sarna",
          tooltipValue: "",
        },
        {
          ownerId: 53,
          intKey: 0,
          stringKey: "4eab3ca3-4cd2-4bba-b046-319e0c40a197",
          stringValue: "NON IATA",
          tooltipValue: "",
        },
        {
          ownerId: 196,
          intKey: 0,
          stringKey: "2adce796-8e3f-4a5f-b6c0-7e4ce5090f7c",
          stringValue: "Patrycja Pokusa",
          tooltipValue: "",
        },
        {
          ownerId: 237,
          intKey: 0,
          stringKey: "287d78ea-29f1-41bd-a994-d96aed48f495",
          stringValue: "Patrycja Preneta",
          tooltipValue: "",
        },
        {
          $id: "75",
          ownerId: 260,
          intKey: 0,
          stringKey: "0d716689-d4e2-48c5-9297-0a044505ce66",
          stringValue: "Patrycja Ryczkowska",
          tooltipValue: "",
        },
        {
          ownerId: 123,
          intKey: 0,
          stringKey: "ae63c10f-a7de-4c21-b2fb-54116f3126f9",
          stringValue: "Paweł Balawender ",
          tooltipValue: "",
        },
        {
          ownerId: 129,
          intKey: 0,
          stringKey: "6f9f3be0-8f9f-4741-a010-baf657ff818b",
          stringValue: "Piotr Trentowski",
          tooltipValue: "",
        },
        {
          ownerId: 223,
          intKey: 0,
          stringKey: "3ff2b195-209c-41b4-8c4a-fba5f4d923fa",
          stringValue: "Przemysław Kijowski",
          tooltipValue: "",
        },
        {
          ownerId: 190,
          intKey: 0,
          stringKey: "cf055e46-1f06-49f8-b854-ebf3dc07945b",
          stringValue: "Sabina Kłosowska",
          tooltipValue: "",
        },
        {
          ownerId: 193,
          intKey: 0,
          stringKey: "1b2a9090-df16-445a-b65a-7260184c96bf",
          stringValue: "Sabina Żurek",
          tooltipValue: "",
        },
        {
          ownerId: 90,
          intKey: 0,
          stringKey: "43ac6600-bd52-4241-99cc-0a167c88f91b",
          stringValue: "Sylwia Janaś",
          tooltipValue: "",
        },
        {
          ownerId: 113,
          intKey: 0,
          stringKey: "84b96e17-3024-4a53-af08-679150d38087",
          stringValue: "Tomasz Gudzio",
          tooltipValue: "",
        },
        {
          ownerId: 170,
          intKey: 0,
          stringKey: "f96e27cb-265b-4a0a-8ce2-50a9c00d8df5",
          stringValue: "Wioletta Chochorowska",
          tooltipValue: "",
        },
        {
          ownerId: 160,
          intKey: 0,
          stringKey: "03034613-eee2-4c0a-bf08-73b0f1d794ff",
          stringValue: "Wioletta Kucharzyk",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 0,
        stringKey: "00000000-0000-0000-0000-000000000000",
        stringValue: "Wszyscy",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
        ownerId: 0,
      },
      type: "EnumOwnerCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 5,
      label: "Kasjer",
      propertyName: "Cashier",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 100,
      value: null,
      type: "TextCriterion",
      Version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 6,
      label: "Cena",
      propertyName: "GrandTotal",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      width: 120,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: null,
          stringValue: "Wszystkie",
          tooltipValue: "",
        },
        {
          intKey: 1,
          stringKey: null,
          stringValue: "Z fakturą",
          tooltipValue: "",
        },
        {
          intKey: 2,
          stringKey: null,
          stringValue: "Bez faktury",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 1,
        stringKey: null,
        stringValue: "Z fakturą",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 7,
      label: "Posiada dokument kosztowy",
      propertyName: "HasCostDocument",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 8,
      label: "Kod agenta",
      propertyName: "AgentCode",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: "MA",
          stringValue: "Manual",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1A",
          stringValue: "Amadeus",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1G",
          stringValue: "Galileo",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1S",
          stringValue: "Sabre",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1P",
          stringValue: "Worldspan",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "TR",
          stringValue: "Tripnet",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "LC",
          stringValue: "Lowcost",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1H",
          stringValue: "HRS",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2H",
          stringValue: "Horse21",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "SP",
          stringValue: "Spark",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1R",
          stringValue: "Rail",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "BC",
          stringValue: "Booking.com",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "GG",
          stringValue: "GoGlobal",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "CI",
          stringValue: "Content Inn",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "AC",
          stringValue: "Accor",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "IH",
          stringValue: "Bezpośrednio w hotelu",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "SI",
          stringValue: "Signal Iduna",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "RA",
          stringValue: "Ratehawk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "XC",
          stringValue: "xTurConnector",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 0,
        stringKey: "MA",
        stringValue: "Manual",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      Version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 9,
      label: "Op.",
      propertyName: "GDS",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: -1,
          stringKey: null,
          stringValue: "Wszystkie",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: null,
          stringValue: "Niegotowa",
          tooltipValue: "",
        },
        {
          intKey: 1,
          stringKey: null,
          stringValue: "Częściowo gotowa",
          tooltipValue: "",
        },
        {
          intKey: 2,
          stringKey: null,
          stringValue: "Gotowa",
          tooltipValue: "",
        },
        {
          intKey: 3,
          stringKey: null,
          stringValue: "Gotowa - zablokowana",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 2,
        stringKey: null,
        stringValue: "Gotowa",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      Version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 10,
      label: "Status rez.",
      propertyName: "BookingItemStatus",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: null,
          stringValue: "Wszyscy",
          tooltipValue: "",
        },
        {
          intKey: 3,
          stringKey: null,
          stringValue: "WNU Rzeszów",
          tooltipValue: "",
        },
        {
          intKey: 5,
          stringKey: null,
          stringValue: "WNU Warszawa",
          tooltipValue: "",
        },
        {
          intKey: 6,
          stringKey: null,
          stringValue: "WNU Kraków",
          tooltipValue: "",
        },
        {
          intKey: 7,
          stringKey: null,
          stringValue: "WNU Lublin",
          tooltipValue: "",
        },
        {
          intKey: 8,
          stringKey: null,
          stringValue: "WNU Krosno",
          tooltipValue: "",
        },
        {
          intKey: 14,
          stringKey: null,
          stringValue: "WNU RZE2",
          tooltipValue: "",
        },
        {
          intKey: 19,
          stringKey: null,
          stringValue: "WNU Kongres",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 0,
        stringKey: null,
        stringValue: "Wszyscy",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 11,
      label: "Oddział",
      propertyName: "Department",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
  ],
};
